export default "__VITE_ASSET__StoPAzq0__"